import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AcceptedClass;
function Accepted() {
  if (AcceptedClass === VOID) {
    class $ {
      toString() {
        return 'Accepted';
      }
      hashCode() {
        return -1588430241;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Accepted()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Accepted');
    AcceptedClass = $;
  }
  return AcceptedClass;
}
var Accepted_instance;
function Accepted_getInstance() {
  return Accepted_instance;
}
var RejectedClass;
function Rejected() {
  if (RejectedClass === VOID) {
    class $ {
      toString() {
        return 'Rejected';
      }
      hashCode() {
        return -50401482;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Rejected()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Rejected');
    RejectedClass = $;
  }
  return RejectedClass;
}
var Rejected_instance;
function Rejected_getInstance() {
  return Rejected_instance;
}
var UnauthorizedClass;
function Unauthorized() {
  if (UnauthorizedClass === VOID) {
    class $ {
      toString() {
        return 'Unauthorized';
      }
      hashCode() {
        return 1478625663;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Unauthorized()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Unauthorized');
    UnauthorizedClass = $;
  }
  return UnauthorizedClass;
}
var Unauthorized_instance;
function Unauthorized_getInstance() {
  return Unauthorized_instance;
}
//region block: init
Accepted_instance = new (Accepted())();
Rejected_instance = new (Rejected())();
Unauthorized_instance = new (Unauthorized())();
//endregion
//region block: exports
export {
  Unauthorized_instance as Unauthorized_instance2jgb1jb3jobqz,
  Accepted_instance as Accepted_instance1051nmidder43,
  Rejected_instance as Rejected_instances6p2tssc0jwo,
};
//endregion

//# sourceMappingURL=CommandResult.mjs.map
